/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: { input: any; output: any; }
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: { input: any; output: any; }
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: { input: any; output: any; }
  /** Serialized as ISO 8601 string */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** A field whose value conforms to the standard DeweyDecimal format as specified by the OCLC https://www.oclc.org/content/dam/oclc/dewey/resources/summaries/deweysummaries.pdf */
  DeweyDecimal: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /**
   * The implementation for this scalar is provided by the
   * 'GraphQLUpload' export from the 'graphql-upload' package
   */
  FileUpload: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: { input: any; output: any; }
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: { input: any; output: any; }
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: { input: any; output: any; }
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: { input: any; output: any; }
  /** A field whose value is either an IPv4 or IPv6 address: https://en.wikipedia.org/wiki/IP_address. */
  IP: { input: any; output: any; }
  /** A field whose value is an IPC Class Symbol within the International Patent Classification System: https://www.wipo.int/classifications/ipc/en/ */
  IPCPatent: { input: any; output: any; }
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: { input: any; output: any; }
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: { input: any; output: any; }
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: { input: any; output: any; }
  /**
   * JSON value as specified by ECMA-404.
   * https://www.graphql-scalars.dev/docs/scalars/json
   */
  JSON: { input: any; output: any; }
  /**
   * JSON object as specified by ECMA-404
   * https://www.graphql-scalars.dev/docs/scalars/json-object
   */
  JSONObject: { input: any; output: any; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any; }
  /** A field whose value conforms to the Library of Congress Subclass Format ttps://www.loc.gov/catdir/cpso/lcco/ */
  LCCSubclass: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: { input: any; output: any; }
  /** Floats that will have a value less than 0. */
  NegativeFloat: { input: any; output: any; }
  /** Integers that will have a value less than 0. */
  NegativeInt: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: { input: any; output: any; }
  /** Floats that will have a value greater than 0. */
  PositiveFloat: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: any; output: any; }
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: { input: any; output: any; }
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: { input: any; output: any; }
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: { input: any; output: any; }
  /** A field whose value conforms to the standard personal number (personnummer) formats for Sweden */
  SESSN: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export enum Align {
  Auto = 'Auto',
  Baseline = 'Baseline',
  Center = 'Center',
  FlexEnd = 'FlexEnd',
  FlexStart = 'FlexStart',
  SpaceAround = 'SpaceAround',
  SpaceBetween = 'SpaceBetween',
  Stretch = 'Stretch'
}

export type AnimationData = {
  /** Animation method to use */
  method: AnimationMethod;
};

export enum AnimationEaseType {
  Anticipate = 'Anticipate',
  BackIn = 'BackIn',
  BackInOut = 'BackInOut',
  BackOut = 'BackOut',
  BounceIn = 'BounceIn',
  BounceInOut = 'BounceInOut',
  BounceOut = 'BounceOut',
  CircIn = 'CircIn',
  CircInOut = 'CircInOut',
  CircOut = 'CircOut',
  EaseIn = 'EaseIn',
  EaseInOut = 'EaseInOut',
  EaseOut = 'EaseOut',
  Linear = 'Linear'
}

/** Data for Interpolate animation */
export type AnimationInterpolateData = AnimationData & {
  __typename?: 'AnimationInterpolateData';
  /**
   * Easing function to use
   * @default Linear
   */
  easeType: Maybe<AnimationEaseType>;
  /** Keyframe times (in s) */
  keyframes: Maybe<Array<Scalars['Float']['output']>>;
  /** Always AnimationMethod.Interpolate */
  method: AnimationMethod;
  /** Values for keyframes */
  values: Maybe<Array<Scalars['String']['output']>>;
};

export enum AnimationMethod {
  Interpolate = 'Interpolate'
}

export type Asset = {
  __typename?: 'Asset';
  /** Flag to indicate that the asset is very bright (e.g. just white) and might require a dark background when previewed */
  bright: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if the logged in user can delete this asset
   * @default false
   */
  deletable: Maybe<Scalars['Boolean']['output']>;
  /** Groups the asset belongs to */
  groups: Maybe<Array<AssetGroup>>;
  /** Id of asset */
  id: Scalars['ID']['output'];
  /** Name of asset */
  name: Scalars['String']['output'];
  /** Url to thumbnail image of asset */
  thumbnailUrl: Scalars['String']['output'];
  /** Url to asset */
  url: Scalars['String']['output'];
};

export type AssetFilter = {
  /** Filter by group */
  groups?: InputMaybe<GroupsFilter>;
  /** Filter by name */
  name?: InputMaybe<NameFilter>;
};

export enum AssetGroup {
  Background = 'Background',
  Packshot = 'Packshot'
}

export type AssetInput = {
  /** Flag to indicate that the asset is very bright (e.g. just white) and might require a dark background when previewed */
  bright?: InputMaybe<Scalars['Boolean']['input']>;
  /** Groups the asset belongs to */
  groups?: InputMaybe<Array<AssetGroup>>;
  /**
   * Name of asset
   * If not set the filename of the uploaded file will be used
   */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AssetQuery = {
  /** Filter that returned assets have to fulfill */
  filter?: InputMaybe<AssetFilter>;
  /**
   * Pagination settings
   * @default First 100 assets
   */
  pagination?: InputMaybe<Pagination>;
};

export type AssetQueryResult = QueryResult & {
  __typename?: 'AssetQueryResult';
  /** Items that matched query, possibly limited to `limit` */
  items: Maybe<Array<Asset>>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type BannerSettings = {
  __typename?: 'BannerSettings';
  /**
   * Disables compression of assets.
   * Useful for testing and previewing a Google Ad package, when you do not need
   * the final file size
   * @default false
   */
  disableCompression: Maybe<Scalars['Boolean']['output']>;
  /**
   * Disables generation of fallback images
   * @default false
   */
  disableFallbackImages: Maybe<Scalars['Boolean']['output']>;
  /**
   * Disables image optimization to speed up export
   * @default false
   */
  disableImageOptimization: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the banner should loop */
  loop: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicate how often the banner should loop.
   * Only considered if `loop` is enabled.
   * @default 3
   */
  loopCount: Maybe<Scalars['Int']['output']>;
  /** Url to navigate to on click */
  targetUrl: Maybe<Scalars['String']['output']>;
};

export type BannerSettingsInput = {
  /**
   * Disables compression of assets.
   * Useful for testing and previewing a Google Ad package, when you do not need
   * the final file size
   * @default false
   */
  disableCompression?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Disables generation of fallback images
   * @default false
   */
  disableFallbackImages?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Disables image optimization to speed up export
   * @default false
   */
  disableImageOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the banner should loop */
  loop?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicate how often the banner should loop.
   * Only considered if `loop` is enabled.
   * @default 3
   */
  loopCount?: InputMaybe<Scalars['Int']['input']>;
  /** Url to navigate to on click */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BlurFilter = {
  __typename?: 'BlurFilter';
  /**
   * The quality of the blur filter.
   * @default 4
   */
  quality: Maybe<Scalars['Float']['output']>;
  /**
   * The strength of the blur filter.
   *      @default 8
   */
  strength: Maybe<Scalars['Float']['output']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  /** Client the campaign belongs to */
  client: Maybe<Client>;
  /** Id of client the campaign belongs to */
  clientId: Maybe<Scalars['ID']['output']>;
  /** Moment when the campaign was created */
  createdAt: Scalars['Date']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Client-specific campaign item settings schema */
  itemSettingsSchema: Maybe<CampaignSettingsSchema>;
  /** Items that belong to this campaign */
  items: Maybe<Array<CampaignItem>>;
  /** Ids of languages that this campaign supports */
  languageIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Languages that this campaign supports */
  languages: Maybe<Array<Language>>;
  /** Descriptive name */
  name: Scalars['String']['output'];
  /** Client-specific campaign settings */
  settings: Maybe<Scalars['JSONObject']['output']>;
  /** Client-specific campaign settings schema */
  settingsSchema: Maybe<CampaignSettingsSchema>;
  /** Moment when the campaign was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type CampaignInput = {
  /**
   * Id of client the campaign belongs to
   * Only used for admin calls, otherwise the client of the user is set.
   */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** Items that belong to this campaign */
  items?: InputMaybe<Array<CampaignItemInput>>;
  /** Ids of languages that this campaign supports */
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Descriptive name */
  name: Scalars['String']['input'];
  /** Initial settings */
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CampaignItem = {
  __typename?: 'CampaignItem';
  /** Moment when the campaign item was created */
  createdAt: Scalars['Date']['output'];
  /** Id of item */
  id: Scalars['ID']['output'];
  /** Instances that belong to this item */
  instances: Maybe<Array<CampaignItemInstance>>;
  /** Name of item */
  name: Maybe<Scalars['String']['output']>;
  /** Client-specific campaign item settings */
  settings: Maybe<Scalars['JSONObject']['output']>;
  /** Template to use */
  template: Maybe<Template>;
  /** Id of template to use */
  templateId: Scalars['ID']['output'];
  /** Moment when the campaign item was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type CampaignItemFilters = {
  /** Filters by the output channels of an item */
  outputChannels?: InputMaybe<CampaignItemOutputChannelsFilter>;
};

export type CampaignItemInput = {
  /**
   * Id of existing item
   * Leave empty to create a new item
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of item */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Client-specific campaign item settings */
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Id of template to use */
  templateId: Scalars['ID']['input'];
};

export type CampaignItemInstance = {
  __typename?: 'CampaignItemInstance';
  /** Campaign item the instance belongs to */
  campaignItem: Maybe<CampaignItem>;
  /** Id of campaign item the instance belongs to */
  campaignItemId: Scalars['ID']['output'];
  /** Moment when the campaign item instance was created */
  createdAt: Scalars['Date']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Language the instance is for */
  language: Maybe<Language>;
  /** Id of language the instance is for */
  languageId: Scalars['ID']['output'];
  /** Template instance */
  templateInstance: Maybe<TemplateInstance>;
  /** Id of template instance */
  templateInstanceId: Scalars['ID']['output'];
  /** Url to thumbnail image for this instance */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** Moment when the campaign item instance was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type CampaignItemOutputChannelsFilter = {
  /** Items are returned that support any of these output channels */
  anyOf?: InputMaybe<Array<OutputChannel>>;
};

export type CampaignItemQuery = {
  /** Id of campaign to get items for */
  campaignId: Scalars['ID']['input'];
  /**
   * Filter to check items with.
   * If not set, all items for the campaign are returned.
   */
  filter?: InputMaybe<CampaignItemFilters>;
};

export type CampaignQuery = {
  _placeholder?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignSettingsFieldOption = {
  __typename?: 'CampaignSettingsFieldOption';
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Name to display for option */
  name: Scalars['String']['output'];
  /** Value to use in the end if option is set */
  value: Scalars['String']['output'];
};

export type CampaignSettingsFieldSchema = {
  __typename?: 'CampaignSettingsFieldSchema';
  /** Unique field id */
  id: Scalars['ID']['output'];
  /** If type is CampaignSettingsFieldValueType.Mapping this property determines what is mapped */
  keyType: Maybe<CampaignSettingsMappingType>;
  /**
   * Type of mapped value
   * @default CampaignSettingsFieldValueType.Text
   */
  mappingValue: Maybe<CampaignSettingsFieldSchema>;
  /** Properties of object field */
  objectProperties: Maybe<Array<CampaignSettingsLeafFieldSchema>>;
  /**
   * Indicates the type of value to display the options accordingly
   * @default CampaignSettingsFieldValueType.Text
   */
  optionValueType: Maybe<CampaignSettingsFieldValueType>;
  /** Fixed set of options to select from */
  options: Maybe<Array<CampaignSettingsFieldOption>>;
  /**
   * Value type of field
   * @default CampaignSettingsFieldValueType.Text
   */
  type: Maybe<CampaignSettingsFieldValueType>;
};

export enum CampaignSettingsFieldValueType {
  Boolean = 'Boolean',
  Color = 'Color',
  Mapping = 'Mapping',
  Object = 'Object',
  Text = 'Text'
}

export type CampaignSettingsLeafFieldSchema = {
  __typename?: 'CampaignSettingsLeafFieldSchema';
  /** Unique field id */
  id: Scalars['ID']['output'];
  /** If type is CampaignSettingsFieldValueType.Mapping this property determines what is mapped */
  keyType: Maybe<CampaignSettingsMappingType>;
  /**
   * Indicates the type of value to display the options accordingly
   * @default CampaignSettingsFieldValueType.Text
   */
  optionValueType: Maybe<CampaignSettingsFieldValueType>;
  /** Fixed set of options to select from */
  options: Maybe<Array<CampaignSettingsFieldOption>>;
  /**
   * Value type of field
   * @default CampaignSettingsFieldValueType.Text
   */
  type: Maybe<CampaignSettingsFieldValueType>;
};

export enum CampaignSettingsMappingType {
  /** Maps values against a format group of the template of the item */
  FormatGroup = 'FormatGroup'
}

export type CampaignSettingsSchema = {
  __typename?: 'CampaignSettingsSchema';
  /** Available settings */
  fields: Maybe<Array<CampaignSettingsFieldSchema>>;
  /** Unique id */
  id: Scalars['ID']['output'];
};

export type Client = {
  __typename?: 'Client';
  /** Ids of campaigns that belong to client */
  campaignIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Campaigns that belong to client */
  campaigns: Maybe<Array<Campaign>>;
  /** Manually set id which is favored to connect the client across multiple tools */
  clientId: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Url to logo of client */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Output configs for this client */
  outputConfigs: Maybe<Array<RenderingOutputConfig>>;
  /** Id of settings schema to use */
  settingsSchemaId: Maybe<Scalars['ID']['output']>;
};

export type ClientCreateInput = {
  /** Manually set id which is favored to connect the client across multiple tools */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Url to logo of client */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClientTemplateFormat = {
  __typename?: 'ClientTemplateFormat';
  /** Client the template format is for */
  client: Maybe<Client>;
  /** Id of client the template format is for */
  clientId: Scalars['ID']['output'];
  /** Template format */
  format: Maybe<TemplateFormat>;
  /** Id of template format */
  formatId: Scalars['ID']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Template the format should be used for */
  template: Maybe<Template>;
  /** Id of template the format should be used for */
  templateId: Scalars['ID']['output'];
};

export type ClientTemplateFormatQuery = {
  /** Id of template to get client template formats for */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientUpdateInput = {
  /** Manually set id which is favored to connect the client across multiple tools */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Url to logo of client */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Output configs for this client */
  outputConfigs?: InputMaybe<Array<RenderingOutputConfigInput>>;
  /** Id of settings schema to use */
  settingsSchemaId?: InputMaybe<Scalars['ID']['input']>;
};

export type Condition = {
  __typename?: 'Condition';
  /** Effects that take place depending on the result of the test */
  effects: Array<ConditionEffect>;
  /** Type of test to use to check which effects take place */
  test: ConditionTestType;
  /** Arguments to pass to test */
  testArgs: Maybe<Array<Scalars['String']['output']>>;
};

export type ConditionEffect = {
  __typename?: 'ConditionEffect';
  /** Animations to set if the effect takes place */
  animations: Maybe<Array<TemplateObjectPropertyAnimation>>;
  /**
   * Result of test to make the effect take place
   * @deprecated Use `Not` test if you have to invert the test result
   * @default true
   */
  result: Maybe<Scalars['Boolean']['output']>;
  /** Property values to set if the effect takes place */
  values: Maybe<Scalars['JSONObject']['output']>;
};

export type ConditionSet = {
  __typename?: 'ConditionSet';
  /** Descriptive name */
  name: Scalars['String']['output'];
  /**
   * Result of test to make the effect take place
   * @default true
   */
  result: Maybe<Scalars['Boolean']['output']>;
  /** Test to check if condition is fulfilled */
  test: ConditionTest;
};

export type ConditionSetInput = {
  /** Descriptive name */
  name: Scalars['String']['input'];
  /**
   * Result of test to make the effect take place
   * @default true
   */
  result?: InputMaybe<Scalars['Boolean']['input']>;
  /** Test to check if condition is fulfilled */
  test: ConditionTestInput;
};

export type ConditionTest = {
  __typename?: 'ConditionTest';
  /** Arguments to pass to test */
  args: Maybe<Array<Scalars['String']['output']>>;
  /** Type of test to perform */
  type: ConditionTestType;
};

export type ConditionTestInput = {
  /** Arguments to pass to test */
  args?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of test to perform */
  type: ConditionTestType;
};

export enum ConditionTestType {
  /** Compare aspect ratio of used format */
  CompareAspectRatio = 'CompareAspectRatio',
  /** Checks if the used format is a landscape format */
  IsLandscapeFormat = 'IsLandscapeFormat',
  /** Inverts the result of the specified test */
  Not = 'Not'
}

export type CreateAssetError = {
  __typename?: 'CreateAssetError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type CreateAssetInput = {
  /** Flag to indicate that the asset is very bright (e.g. just white) and might require a dark background when previewed */
  bright?: InputMaybe<Scalars['Boolean']['input']>;
  /** Asset file to upload */
  file: Scalars['FileUpload']['input'];
  /** Groups the asset belongs to */
  groups?: InputMaybe<Array<AssetGroup>>;
  /**
   * Name of asset
   * If not set the filename of the uploaded file will be used
   */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetResult = CreateAssetError | CreateAssetSuccess;

export type CreateAssetSuccess = {
  __typename?: 'CreateAssetSuccess';
  /** Created asset */
  asset: Asset;
};

export type CreateClientTemplateFormatInput = {
  /** Template format input */
  format: CreateTemplateFormatInput;
  /** Id of template to use format for */
  templateId: Scalars['ID']['input'];
};

export type CreateTemplateFormatInput = {
  /** Id of group the format belongs to */
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Height (in px) */
  height: Scalars['Int']['input'];
  /** Indicates if the format exports to a print asset */
  isPrint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of layout the format uses */
  layoutId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of format */
  name: Scalars['String']['input'];
  /** Scale factor to use on export */
  scale?: InputMaybe<Scalars['Float']['input']>;
  /** Width (in px) */
  width: Scalars['Int']['input'];
};

export type Creative = {
  __typename?: 'Creative';
  /** Id in an external system */
  externalId: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Template the creative uses */
  template: Maybe<Template>;
  /** Id of template the creative uses */
  templateId: Scalars['ID']['output'];
  /** Template instance the creative uses */
  templateInstance: Maybe<TemplateInstance>;
  /** Id of template instance the creative uses */
  templateInstanceId: Scalars['ID']['output'];
};

export type CreativeCreate = {
  /** Id in an external system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Id of template to use */
  templateId: Scalars['ID']['input'];
};

export type CreativeQuery = {
  /** Id in an external system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Id of template to use */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type CroppingFrame = {
  __typename?: 'CroppingFrame';
  /**
   * The overall height of the frame
   * @default Full height
   */
  height: Maybe<Scalars['Float']['output']>;
  /**
   * Unit of frame values
   * @default Pixel
   */
  unit: Maybe<LengthUnit>;
  /**
   * The overall width of the frame
   * @default Full width
   */
  width: Maybe<Scalars['Float']['output']>;
  /**
   * The X coordinate of the upper-left corner of the frame
   * @default 0
   */
  x: Maybe<Scalars['Float']['output']>;
  /**
   * The Y coordinate of the upper-left corner of the frame
   * @default 0
   */
  y: Maybe<Scalars['Float']['output']>;
};

export type Dimension = {
  __typename?: 'Dimension';
  fixed: Maybe<Length>;
  max: Maybe<Length>;
  min: Maybe<Length>;
};

export type DisplacementFilter = {
  __typename?: 'DisplacementFilter';
  /**
   * Id of mask to use.
   * Either this or `src` has to be set.
   */
  maskId: Maybe<Scalars['String']['output']>;
  /** Scale of the displacement */
  scale: Maybe<Scalars['Float']['output']>;
  /**
   * Path to the displacement map image
   * Either this or `maskId` has to be set.
   */
  src: Maybe<Scalars['String']['output']>;
};

export type DuplicateCampaignInput = {
  /** Id of campaign to duplicate */
  campaignId: Scalars['ID']['input'];
  /** Descriptive name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Flag to ignore format values when duplicating campaign item instances
   * @default false
   */
  skipFormatValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuplicateCampaignItemInput = {
  /** Id of campaign item to duplicate */
  campaignItemId: Scalars['ID']['input'];
  /**
   * Descriptive name for duplicated item
   * @default `${ORIGINAL_CAMPAIGN_ITEM_NAME} (Copy)`
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Flag to ignore format values when duplicating campaign item instances
   * @default false
   */
  skipFormatValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportTemplateOptions = {
  /**
   * Formats are just referenced in a template.
   * They can be included to make the template work without a lookup.
   */
  includeFormats?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportTemplateResult = {
  __typename?: 'ExportTemplateResult';
  /** Url to download exported template from */
  downloadUrl: Scalars['String']['output'];
};

export enum FlexDirection {
  Column = 'Column',
  ColumnReverse = 'ColumnReverse',
  Row = 'Row',
  RowReverse = 'RowReverse'
}

export type Font = {
  __typename?: 'Font';
  /** Font face */
  face: FontFace;
  /** Url to load font from */
  src: Scalars['String']['output'];
};

export type FontFace = {
  __typename?: 'FontFace';
  /** Family */
  family: Scalars['String']['output'];
  /**
   * Style
   * @default normal
   */
  style: Maybe<FontStyle>;
  /**
   * Weight
   * @default normal
   */
  weight: Maybe<FontWeight>;
};

export type FontFaceInput = {
  /** Family */
  family: Scalars['String']['input'];
  /**
   * Style
   * @default normal
   */
  style?: InputMaybe<FontStyle>;
  /**
   * Weight
   * @default normal
   */
  weight?: InputMaybe<FontWeightNumericInput>;
};

export type FontInput = {
  /** Font face */
  face: FontFaceInput;
  /** Url to load font from */
  src: Scalars['String']['input'];
};

export enum FontStyle {
  Italic = 'italic',
  Normal = 'normal',
  Oblique = 'oblique'
}

export type FontWeight = FontWeightNumeric | FontWeightText;

export type FontWeightNumeric = {
  __typename?: 'FontWeightNumeric';
  numeric: Maybe<Scalars['Int']['output']>;
};

export type FontWeightNumericInput = {
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

export type FontWeightText = {
  __typename?: 'FontWeightText';
  value: Maybe<FontWeightValue>;
};

export enum FontWeightValue {
  Bold = 'bold',
  Bolder = 'bolder',
  Lighter = 'lighter',
  Normal = 'normal'
}

export type GroupsFilter = {
  /** Asset has to be in any of the specified groups */
  anyOf?: InputMaybe<Array<AssetGroup>>;
  /** Asset must not be in any of the specified groups */
  noneOf?: InputMaybe<Array<AssetGroup>>;
};

export type ImageSequenceSource = {
  __typename?: 'ImageSequenceSource';
  /**
   * Format string to create source url from for each frame.
   * Uses ${FRAME:X} as placeholder. X specifies the length of the number, i.e. how many zeros are prepended.
   */
  baseSrc: Scalars['String']['output'];
  /** Frames per second */
  fps: Scalars['Int']['output'];
  /** Total frames */
  frameCount: Scalars['Int']['output'];
  /**
   * Index of start frame.
   * @default 0
   */
  startFrame: Maybe<Scalars['Int']['output']>;
  /**
   * Offset to start playing (in s)
   * @default 0
   */
  timeOffset: Maybe<Scalars['Float']['output']>;
};

export enum JustifyContent {
  Center = 'Center',
  FlexEnd = 'FlexEnd',
  FlexStart = 'FlexStart',
  SpaceAround = 'SpaceAround',
  SpaceBetween = 'SpaceBetween',
  SpaceEvenly = 'SpaceEvenly'
}

export type Language = {
  __typename?: 'Language';
  /** Unique id */
  id: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
};

export type Length = {
  __typename?: 'Length';
  unit: LengthUnit;
  value: Scalars['Float']['output'];
};

export enum LengthUnit {
  Percent = 'Percent',
  Pixel = 'Pixel',
  ViewportHeight = 'ViewportHeight',
  ViewportWidth = 'ViewportWidth'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancels the rendering job with the specified id */
  cancelRenderingJob: RenderingJob;
  /** Copy an existing template */
  copyTemplate: Template;
  /** Creates a new asset */
  createAsset: Asset;
  /** Creates new assets */
  createAssets: Array<CreateAssetResult>;
  /** Creates a new campaign */
  createCampaign: Campaign;
  /** Creates a new client */
  createClient: Client;
  /** Creates a new format */
  createClientFormat: ClientTemplateFormat;
  /** Creates a new creative */
  createCreative: Creative;
  /** Creates a new format */
  createFormat: TemplateFormat;
  /** Creates a new rendering job */
  createRenderingJob: RenderingJob;
  /** Creates a new template */
  createTemplate: Template;
  /** Creates a new template instance */
  createTemplateInstance: TemplateInstance;
  /**
   * Deletes the asset with the specified id
   * @returns Deleted asset
   */
  deleteAsset: Asset;
  /** Deletes a campaign */
  deleteCampaign: Campaign;
  /** Deletes a client */
  deleteClient: Client;
  /** Deletes the format with the specified id */
  deleteClientFormat: ClientTemplateFormat;
  /** Delete the creative with the specified id */
  deleteCreative: Creative;
  /** Deletes the format with the specified id */
  deleteFormat: TemplateFormat;
  /** Deletes a template */
  deleteTemplate: Template;
  /** Deletes the template instance with the specified id */
  deleteTemplateInstance: TemplateInstance;
  /** Duplicates a campaign */
  duplicateCampaign: Campaign;
  /** Duplicates a campaign */
  duplicateCampaignItem: CampaignItem;
  /** Exports a template to JSON and provides a download link */
  exportTemplate: ExportTemplateResult;
  /** Searches for an existing creative first. If none exists, creates one. */
  getOrCreateCreative: Creative;
  /** Imports JSON as a new template */
  importTemplate: Template;
  /** Starts a rendering of the specified template */
  renderTemplate: Rendering;
  /** Starts a rendering of the specified template instance */
  renderTemplateInstance: Rendering;
  /** Resets an existing template instance, i.e. removes all changes */
  resetTemplateInstance: TemplateInstance;
  /** Updates an existing campaign */
  updateCampaign: Campaign;
  /** Updates an existing client */
  updateClient: Client;
  /** Updates the format with the specified id */
  updateClientFormat: ClientTemplateFormat;
  /** Updates the format with the specified id */
  updateFormat: TemplateFormat;
  /** Updates an existing template */
  updateTemplate: Template;
  /** Updates an existing template instance */
  updateTemplateInstance: TemplateInstance;
};


export type MutationCancelRenderingJobArgs = {
  renderingJobId: Scalars['ID']['input'];
};


export type MutationCopyTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationCreateAssetArgs = {
  file: Scalars['FileUpload']['input'];
  input: AssetInput;
};


export type MutationCreateAssetsArgs = {
  inputs: Array<CreateAssetInput>;
};


export type MutationCreateCampaignArgs = {
  input: CampaignInput;
};


export type MutationCreateClientArgs = {
  input: ClientCreateInput;
};


export type MutationCreateClientFormatArgs = {
  input: CreateClientTemplateFormatInput;
};


export type MutationCreateCreativeArgs = {
  data: CreativeCreate;
};


export type MutationCreateFormatArgs = {
  input: CreateTemplateFormatInput;
};


export type MutationCreateRenderingJobArgs = {
  input: RenderingJobInput;
};


export type MutationCreateTemplateArgs = {
  data: TemplateCreate;
};


export type MutationCreateTemplateInstanceArgs = {
  data: TemplateInstanceCreate;
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientFormatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCreativeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateCampaignArgs = {
  input: DuplicateCampaignInput;
};


export type MutationDuplicateCampaignItemArgs = {
  input: DuplicateCampaignItemInput;
};


export type MutationExportTemplateArgs = {
  id: Scalars['ID']['input'];
  options?: InputMaybe<ExportTemplateOptions>;
};


export type MutationGetOrCreateCreativeArgs = {
  data: CreativeCreate;
  query: CreativeQuery;
};


export type MutationImportTemplateArgs = {
  contents: Scalars['JSONObject']['input'];
};


export type MutationRenderTemplateArgs = {
  input: RenderingInput;
  templateId: Scalars['ID']['input'];
};


export type MutationRenderTemplateInstanceArgs = {
  input: RenderingInput;
  templateInstanceId: Scalars['ID']['input'];
};


export type MutationResetTemplateInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCampaignInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: ClientUpdateInput;
};


export type MutationUpdateClientFormatArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientTemplateFormatInput;
};


export type MutationUpdateFormatArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTemplateFormatInput;
};


export type MutationUpdateTemplateArgs = {
  data: TemplateUpdate;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTemplateInstanceArgs = {
  data: TemplateInstanceUpdate;
  id: Scalars['ID']['input'];
};

export type NameFilter = {
  /** Term the name has to contain */
  contains?: InputMaybe<Scalars['String']['input']>;
};

export enum OutputChannel {
  Banner = 'Banner',
  Print = 'Print',
  Still = 'Still',
  Video = 'Video'
}

export type Pagination = {
  /**
   * Set the maximum number of items that will be returned
   * @default 100
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Skip the first n items in the response
   * @default 0
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export enum PositionType {
  Absolute = 'Absolute',
  AbsoluteLegacy = 'AbsoluteLegacy',
  Relative = 'Relative'
}

export type Query = {
  __typename?: 'Query';
  /** Returns the asset with the specified id */
  asset: Asset;
  /** Returns all assets that match the specified query */
  assets: AssetQueryResult;
  /** Returns the campaign with the specified id */
  campaign: Campaign;
  /** Returns all campaign items that match the specified query */
  campaignItems: Array<CampaignItem>;
  /** Returns all campaigns that match the specified query */
  campaigns: Array<Campaign>;
  /** Returns the client with the specified id */
  client: Client;
  /** Get the client template format with the specified id */
  clientFormat: ClientTemplateFormat;
  /** Get client template formats that match the specified query */
  clientFormats: Array<ClientTemplateFormat>;
  /** Returns all clients that match the specified query */
  clients: Array<Client>;
  /** Returns the creative with the specified id */
  creative: Creative;
  /** All available creatives */
  creatives: Array<Creative>;
  format: TemplateFormat;
  formats: Array<TemplateFormat>;
  /** Returns the translation for the specified request */
  getTranslation: TranslationResponse;
  hello: Scalars['String']['output'];
  /** Supported languages */
  languages: Array<Language>;
  /** Info about the logged in user */
  me: Maybe<User>;
  /** Returns the rendering with the specified id */
  rendering: Rendering;
  /** Returns the rendering job with the specified id */
  renderingJob: RenderingJob;
  /** Returns rendering jobs that match the specified query */
  renderingJobs: RenderingJobQueryResult;
  /** Returns the template with the specified id */
  template: Template;
  /** Returns the template instance with the specified id */
  templateInstance: TemplateInstance;
  /** Returns all available templates */
  templates: Array<Template>;
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetsArgs = {
  query?: InputMaybe<AssetQuery>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignItemsArgs = {
  query: CampaignItemQuery;
};


export type QueryCampaignsArgs = {
  query?: InputMaybe<CampaignQuery>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientFormatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientFormatsArgs = {
  query?: InputMaybe<ClientTemplateFormatQuery>;
};


export type QueryCreativeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreativesArgs = {
  query?: InputMaybe<CreativeQuery>;
};


export type QueryFormatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTranslationArgs = {
  request: TranslationRequest;
};


export type QueryHelloArgs = {
  name: Scalars['String']['input'];
};


export type QueryRenderingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRenderingJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRenderingJobsArgs = {
  query: RenderingJobQuery;
};


export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplateInstanceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryParameter = {
  __typename?: 'QueryParameter';
  /** Name of query parameter */
  name: Scalars['String']['output'];
  /** Value of query parameter */
  value: Scalars['String']['output'];
};

export type QueryParameterInput = {
  /** Name of query parameter */
  name: Scalars['String']['input'];
  /** Value of query parameter */
  value: Scalars['String']['input'];
};

export type QueryResult = {
  /**
   * Maximum number of items to return
   * Used for pagination.
   */
  limit: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items to skip from result before returning.
   * Used for pagination.
   */
  offset: Maybe<Scalars['Int']['output']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page: Maybe<Scalars['Int']['output']>;
  /** Total number of items that matched the query */
  totalCount: Scalars['Int']['output'];
};

export type RenderSettings = {
  __typename?: 'RenderSettings';
  /** Settings to use for banner export */
  bannerSettings: Maybe<BannerSettings>;
};

export type RenderSettingsInput = {
  /** Settings to use for banner export */
  bannerSettings?: InputMaybe<BannerSettingsInput>;
};

export type Rendering = {
  __typename?: 'Rendering';
  /** Campaign item instance to render */
  campaignItemInstance: Maybe<CampaignItemInstance>;
  /** Id of campaign item instance to render */
  campaignItemInstanceId: Maybe<Scalars['ID']['output']>;
  /** Name of rendering */
  displayName: Maybe<Scalars['String']['output']>;
  /** Moment when rendering finished */
  end: Maybe<Scalars['Date']['output']>;
  /** Specifies the target the template is exported to */
  exportTarget: RenderingExportTarget;
  /** Mail address to send notification to when rendering was finished */
  finishedNotificationMailAddress: Maybe<Scalars['String']['output']>;
  /** Pre-defined format the rendering uses */
  format: Maybe<TemplateFormat>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Concrete rendering format the rendering uses */
  renderingFormat: RenderingFormat;
  /**
   * Resolution to render with (in px)
   * It specifies the length of the smallest dimension.
   */
  resolution: Maybe<Scalars['Int']['output']>;
  /**
   * Query parameters to append to resource urls
   * Those are necessary if resources (e.g. images) require authorization.
   */
  resourceQueryParameters: Maybe<Array<QueryParameter>>;
  /** Result if status is `Finished` or `Failed` */
  result: Maybe<RenderingResultOrError>;
  /** Settings to use for rendering */
  settings: Maybe<RenderSettings>;
  /** Moment when rendering started */
  start: Maybe<Scalars['Date']['output']>;
  /** Current status */
  status: RenderingStatus;
  /** Template the rendering is for */
  template: Maybe<Template>;
  /** Id of template the rendering is for */
  templateId: Scalars['ID']['output'];
  /** Template instance the rendering is for */
  templateInstance: Maybe<TemplateInstance>;
  /** Id of template instance the rendering is for */
  templateInstanceId: Maybe<Scalars['ID']['output']>;
};

export type RenderingError = {
  __typename?: 'RenderingError';
  /** Error message */
  message: Scalars['String']['output'];
};

export enum RenderingExportTarget {
  /** Google Ads HTML banner */
  GoogleAd = 'GoogleAd',
  /** JSON format */
  Json = 'Json',
  /** MP4 video */
  Mp4 = 'Mp4',
  /** Print-ready PDF */
  Pdf = 'Pdf',
  /** PNG image */
  Png = 'Png',
  /** Layered Tif image */
  Tif = 'Tif'
}

export type RenderingFormat = {
  __typename?: 'RenderingFormat';
  /** Id of format if a pre-defined format was used */
  formatId: Maybe<Scalars['String']['output']>;
  /** Id of group if a pre-defined format was used */
  groupId: Maybe<Scalars['String']['output']>;
  /** Height to use (in px) */
  height: Scalars['Int']['output'];
  /** Id of layout to use */
  layoutId: Maybe<Scalars['String']['output']>;
  /** Name if a pre-defined format was used */
  name: Maybe<Scalars['String']['output']>;
  /** Width to use (in px) */
  width: Scalars['Int']['output'];
};

export type RenderingFormatInput = {
  /** Height to use (in px) */
  height: Scalars['Int']['input'];
  /** Id of layout to use */
  layoutId?: InputMaybe<Scalars['String']['input']>;
  /** Width to use (in px) */
  width: Scalars['Int']['input'];
};

export type RenderingInput = {
  /**
   * Specifies the target to export the template to
   * @default First export target which is not disabled for the used template
   */
  exportTarget?: InputMaybe<RenderingExportTarget>;
  /** Mail address to send notification to when rendering was finished */
  finishedNotificationMailAddress?: InputMaybe<Scalars['String']['input']>;
  /**
   * User-defined format to use.
   * If set it takes precedence over `formatIndex`, `formatId` and `resolution`
   */
  format?: InputMaybe<RenderingFormatInput>;
  /**
   * Id of format to use.
   * If set it takes precedence over `formatIndex` property.
   */
  formatId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Index of format to use
   * @default 0
   */
  formatIndex?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Resolution to render with (in px).
   * It specifies the length of the smallest dimension.
   * @default Uses the dimensions defined by the format
   */
  resolution?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Query parameters to append to resource urls.
   * Those are necessary if resources (e.g. images) require authorization.
   */
  resourceQueryParameters?: InputMaybe<Array<QueryParameterInput>>;
  /** Settings to use for rendering */
  settings?: InputMaybe<RenderSettingsInput>;
};

export type RenderingJob = {
  __typename?: 'RenderingJob';
  /**
   * Id of campaign the job was started for
   * Only set if provided by the initiator
   */
  campaignId: Maybe<Scalars['ID']['output']>;
  /** Moment when rendering job finished */
  end: Maybe<Scalars['Date']['output']>;
  /** Mail address to send notification to when rendering job was finished */
  finishedNotificationMailAddress: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Name of the rendering job, given by the initiator */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if the rendering job should be used on a preview page */
  preview: Scalars['Boolean']['output'];
  /** Url to preview page. Only available if rendering job was successful */
  previewUrl: Maybe<Scalars['String']['output']>;
  /** Ids of renderings that belong to job */
  renderingIds: Array<Scalars['String']['output']>;
  /** Renderings that belong to job */
  renderings: Maybe<Array<Rendering>>;
  /**
   * Query parameters to append to resource urls.
   * Those are necessary if resources (e.g. images) require authorization.
   */
  resourceQueryParameters: Maybe<Array<QueryParameter>>;
  /** Result if finished */
  result: Maybe<RenderingJobResult>;
  /** Moment when rendering job created/started */
  start: Scalars['Date']['output'];
  /** Current status */
  status: RenderingJobStatus;
  /**
   * Id of template instance the job is for
   * Only set if all rendering items render the same template instance
   */
  templateInstanceId: Maybe<Scalars['ID']['output']>;
};

export type RenderingJobError = {
  __typename?: 'RenderingJobError';
  /** Error message */
  message: Scalars['String']['output'];
};

export type RenderingJobInput = {
  /** Id of campaign this job is for */
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Id of campaign item instance to render
   * If not set, each rendering job item has to have a campaign item instance id
   */
  campaignItemInstanceId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specifies the target to export the template to
   * @default RenderingTarget.Binary
   */
  exportTarget?: InputMaybe<RenderingExportTarget>;
  /** Mail address to send notification to when rendering job was finished */
  finishedNotificationMailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Name of the rendering job, given by the initiator */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates if the rendering job should be used on a preview page
   * @default false
   */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Renderings to do */
  renderings: Array<RenderingJobItemInput>;
  /**
   * Query parameters to append to resource urls.
   * Those are necessary if resources (e.g. images) require authorization.
   */
  resourceQueryParameters?: InputMaybe<Array<QueryParameterInput>>;
  /**
   * Id of template instance to render
   * If not set, each rendering job item has to have a template instance id
   */
  templateInstanceId?: InputMaybe<Scalars['ID']['input']>;
};

export type RenderingJobItemInput = {
  /**
   * Id of campaign item instance to render
   * @default Campaign Item Instance Id from rendering job
   */
  campaignItemInstanceId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specifies the target to export the template to
   * @default Export target from rendering job
   */
  exportTarget?: InputMaybe<RenderingExportTarget>;
  /**
   * Id of format to use.
   * If set it takes precedence over `formatIndex` property.
   */
  formatId?: InputMaybe<Scalars['ID']['input']>;
  /** Index of format to use */
  formatIndex?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Resolution to render with (in px).
   * It specifies the length of the smallest dimension.
   * @default Uses the dimensions defined by the format
   */
  resolution?: InputMaybe<Scalars['Int']['input']>;
  /** Settings to use for rendering */
  settings?: InputMaybe<RenderSettingsInput>;
  /**
   * Id of template instance to render
   * @default Template Instance Id from rendering job
   */
  templateInstanceId?: InputMaybe<Scalars['ID']['input']>;
};

export type RenderingJobQuery = {
  /** Limits the number of the returned jobs */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Sort settings */
  sort?: InputMaybe<RenderingJobQuerySort>;
  /** Id of template instance id the job is for */
  templateInstanceId?: InputMaybe<Scalars['ID']['input']>;
};

export type RenderingJobQueryResult = {
  __typename?: 'RenderingJobQueryResult';
  /** Items that match the query */
  items: Array<RenderingJob>;
};

export type RenderingJobQuerySort = {
  /** Direction of order */
  direction: RenderingJobQuerySortDirection;
  /** Field to order by */
  field: Scalars['String']['input'];
};

export enum RenderingJobQuerySortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type RenderingJobResult = RenderingJobError | RenderingJobSuccess;

export enum RenderingJobStatus {
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  Queued = 'Queued',
  Running = 'Running'
}

export type RenderingJobSuccess = {
  __typename?: 'RenderingJobSuccess';
  /** Moment until result will be available */
  availableUntil: Scalars['Date']['output'];
  /** Size of result (in bytes) */
  size: Scalars['Int']['output'];
  /** Url to download result from */
  url: Scalars['String']['output'];
};

export type RenderingOutputConfig = {
  __typename?: 'RenderingOutputConfig';
  /** Parts to build output name from */
  nameParts: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Separator to join name parts
   * @default "-"
   */
  partSeparator: Maybe<Scalars['String']['output']>;
  /** Targets this config should be used for */
  targets: Maybe<Array<RenderingExportTarget>>;
};

export type RenderingOutputConfigInput = {
  /** Parts to build output name from */
  nameParts?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Separator to join name parts
   * @default "-"
   */
  partSeparator?: InputMaybe<Scalars['String']['input']>;
  /** Targets this config should be used for */
  targets?: InputMaybe<Array<RenderingExportTarget>>;
};

export type RenderingResult = {
  __typename?: 'RenderingResult';
  /** Moment until result will be available */
  availableUntil: Scalars['Date']['output'];
  /** Url to download result from */
  downloadUrl: Scalars['String']['output'];
  /** Url to preview result */
  previewUrl: Scalars['String']['output'];
  /** Url to display result */
  url: Scalars['String']['output'];
};

export type RenderingResultOrError = RenderingError | RenderingResult;

export enum RenderingStatus {
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  Queued = 'Queued',
  Running = 'Running'
}

export type SelectedTemplateTextOption = {
  __typename?: 'SelectedTemplateTextOption';
  /** Index of selected option */
  optionIndex: Maybe<Scalars['Int']['output']>;
  /** Mappings of variables to concrete values */
  variableMappings: Maybe<Array<TemplateTextOptionVariableMapping>>;
};

export type ShadowFilter = {
  __typename?: 'ShadowFilter';
  /**
   * Strength of the blur of the shadow
   * @default 2
   */
  blur: Maybe<Scalars['Float']['output']>;
  /**
   * Color of the shadow (in hex)
   * @default 0x000000 black
   */
  color: Maybe<Scalars['Int']['output']>;
  /**
   * Distance of shadow
   * @default 5
   */
  distance: Maybe<Scalars['Float']['output']>;
  /**
   * Angle of the shadow (in degrees)
   * @default 45
   */
  rotation: Maybe<Scalars['Float']['output']>;
  /**
   * Hides the object to only render the shadow
   * @default false
   */
  shadowOnly: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  helloRequested: Maybe<Scalars['String']['output']>;
  /** Subscribes for rendering job status changes */
  renderingJobStatusChanged: RenderingJob;
  /** Subscribes for rendering status changes */
  renderingStatusChanged: Rendering;
};


export type SubscriptionRenderingJobStatusChangedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionRenderingStatusChangedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Template = {
  __typename?: 'Template';
  /**
   * Client the template belongs to
   * @deprecated Use `clients` instead. This will only return first client.
   */
  client: Maybe<Client>;
  /** Client template formats for this template */
  clientFormats: Maybe<Array<ClientTemplateFormat>>;
  /**
   * Id of client the template belongs to
   * @deprecated Use `clientIds` instead. This will only return first client.
   */
  clientId: Maybe<Scalars['ID']['output']>;
  /** Ids of clients the template belongs to */
  clientIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Clients the template belongs to */
  clients: Maybe<Array<Client>>;
  /** Condition sets of template */
  conditionSets: Maybe<Array<ConditionSet>>;
  /** Default font family to use */
  defaultFontFamily: Maybe<Scalars['String']['output']>;
  /** Export targets that are disabled for this template */
  disabledRenderingExportTargets: Maybe<Array<RenderingExportTarget>>;
  /** Fonts to use */
  fonts: Maybe<Array<Font>>;
  /** Available format groups */
  formatGroups: Maybe<Array<TemplateFormatGroup>>;
  /** Ids of available formats */
  formatIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Available formats */
  formats: Maybe<Array<TemplateFormat>>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Instances that use this template */
  instances: Maybe<Array<TemplateInstance>>;
  /** Special layouts that are used if formats are too different */
  layouts: Maybe<Array<TemplateLayout>>;
  /** Indicates if the template spans over multiple frames */
  motion: Maybe<TemplateMotion>;
  /** Descriptive name */
  name: Scalars['String']['output'];
  /** Objects in template */
  objects: Array<TemplateObject>;
  /** Output channels the template supports */
  outputChannels: Maybe<Array<OutputChannel>>;
  /** Returns the data required to render the template with the `TemplatePlayer` */
  playerTemplate: Maybe<Scalars['JSONObject']['output']>;
  /** Valid export targets for this template */
  renderingExportTargets: Maybe<Array<RenderingExportTarget>>;
  /** Variable mappings of the template */
  variableMappings: Maybe<Array<TemplateVariableMapping>>;
};

export type TemplateAudio = {
  __typename?: 'TemplateAudio';
  src: Scalars['String']['output'];
};

export type TemplateAudioInput = {
  src: Scalars['String']['input'];
};

export type TemplateColor = {
  /** Color value (hex code) */
  color: Maybe<Scalars['String']['output']>;
  /**
   * Options for color to choose from.
   * If not set the user is free to choose any color.
   */
  colorOptions: Maybe<Array<TemplateColorOption>>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence over `color` property.
   */
  selectedColorOption: Maybe<Scalars['Int']['output']>;
};

export type TemplateColorOption = {
  __typename?: 'TemplateColorOption';
  /** Descriptive name */
  name: Maybe<Scalars['String']['output']>;
  /** Color (hex code) */
  value: Scalars['String']['output'];
};

export type TemplateContainer = TemplateObjectContent & {
  __typename?: 'TemplateContainer';
  /**
   * Alignment of children on the cross axis (i.e. perpendicular to direction)
   * @default Align Auto
   */
  alignItems: Maybe<Align>;
  /** Background behind content */
  background: Maybe<TemplateObjectBackground>;
  /**
   * Direction to place children
   * @default FlexDirection Row
   */
  flexDirection: Maybe<FlexDirection>;
  /**
   * Alignment of content on main axis
   * @default JustifyContent FlexStart
   */
  justifyContent: Maybe<JustifyContent>;
  /**
   * Keeps the child proportions by scaling all children the same to fill the container space
   * If enabled, `flexShrink`, `flexGrow` and `flexBasis` of children have no effect.
   */
  keepChildProportions: Maybe<Scalars['Boolean']['output']>;
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateCreate = {
  /** Ids of clients the template belongs to */
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name */
  name: Scalars['String']['input'];
};

export type TemplateEllipse = TemplateObjectContent & {
  __typename?: 'TemplateEllipse';
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateFormat = {
  __typename?: 'TemplateFormat';
  /** Id of group the format belongs to */
  groupId: Maybe<Scalars['String']['output']>;
  /** Height (in px) */
  height: Scalars['Int']['output'];
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Indicates if the format exports to a print asset */
  isPrint: Maybe<Scalars['Boolean']['output']>;
  /**
   * Id of layout this format uses
   * @deprecated Mapping is done on template layout
   */
  layoutId: Maybe<Scalars['ID']['output']>;
  /** Name of format */
  name: Scalars['String']['output'];
  /**
   * Scale factor to use on export
   * @default 1
   */
  scale: Maybe<Scalars['Float']['output']>;
  /** Templates that use this format */
  templates: Maybe<Array<Template>>;
  /** Width (in px) */
  width: Scalars['Int']['output'];
};

export type TemplateFormatGroup = {
  __typename?: 'TemplateFormatGroup';
  /** Formats that belong to this group */
  formats: Maybe<Array<TemplateFormat>>;
  /** Unique id of group */
  id: Scalars['ID']['output'];
  /** Name of group */
  name: Scalars['String']['output'];
};

export type TemplateGradient = TemplateObjectContent & {
  __typename?: 'TemplateGradient';
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateHolder = TemplateObjectContent & {
  __typename?: 'TemplateHolder';
  /** Id of content object to show */
  referenceId: Maybe<Scalars['String']['output']>;
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateImage = TemplateObjectContent & {
  __typename?: 'TemplateImage';
  /** Asset groups to choose image from */
  assetGroups: Maybe<Array<AssetGroup>>;
  /** Background behind content */
  background: Maybe<TemplateObjectBackground>;
  /**
   * The rectangle frame of the image to show
   * If not set the whole image is displayed
   */
  frame: Maybe<CroppingFrame>;
  /**
   * Fixed height to use (in px)
   * @deprecated Use `TemplateObject.height` instead
   */
  height: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum height to use (in px)
   * @deprecated Use `TemplateObject.height.max` instead
   */
  maxHeight: Maybe<Scalars['Float']['output']>;
  /**
   * Maximum width to use (in px)
   * @deprecated Use `TemplateObject.width.max` instead
   */
  maxWidth: Maybe<Scalars['Float']['output']>;
  /** Options to choose from */
  options: Maybe<Array<TemplateImageOption>>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence before `src` property.
   */
  selectedOption: Maybe<TemplateImageSelectedOption>;
  /** Url to image source */
  src: Maybe<Scalars['String']['output']>;
  /** Type of content */
  type: TemplateObjectType;
  /**
   * Fixed width to use (in px)
   * @deprecated Use `TemplateObject.width` instead
   */
  width: Maybe<Scalars['Float']['output']>;
};

export type TemplateImageOption = {
  __typename?: 'TemplateImageOption';
  /** Descriptive name */
  name: Scalars['String']['output'];
  /** Source to image */
  src: Scalars['String']['output'];
  /**
   * Variants of image.
   * Those variants are very similar to each other, so they can be grouped.
   */
  variants: Maybe<Array<TemplateImageVariant>>;
};

export type TemplateImageSelectedOption = {
  __typename?: 'TemplateImageSelectedOption';
  /** Index of option to select */
  optionIndex: Scalars['Int']['output'];
  /** Index of option variant to select */
  variantIndex: Maybe<Scalars['Int']['output']>;
};

export type TemplateImageSequence = TemplateObjectContent & {
  __typename?: 'TemplateImageSequence';
  /** Background behind content */
  background: Maybe<TemplateObjectBackground>;
  /** Current sequence */
  currentSequence: Maybe<ImageSequenceSource>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence before `currentSequence` property.
   */
  selectedOption: Maybe<TemplateImageSequenceSelectedOption>;
  /** Options to choose from */
  sequenceOptions: Maybe<Array<TemplateImageSequenceOption>>;
  /**
   * Speed to play sequence with. Can be used to play the sequence faster or
   * backwards (speed -1.0).
   * @default 1.0
   */
  speed: Maybe<Scalars['Float']['output']>;
  /** Offset to start playing (in s) */
  timeOffset: Maybe<Scalars['Float']['output']>;
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateImageSequenceOption = {
  __typename?: 'TemplateImageSequenceOption';
  /** Descriptive name */
  name: Scalars['String']['output'];
  /** Source */
  src: ImageSequenceSource;
};

export type TemplateImageSequenceSelectedOption = {
  __typename?: 'TemplateImageSequenceSelectedOption';
  /** Index of option to select */
  optionIndex: Scalars['Int']['output'];
};

export type TemplateImageVariant = {
  __typename?: 'TemplateImageVariant';
  /** Descriptive name */
  name: Scalars['String']['output'];
  /** Source to image */
  src: Scalars['String']['output'];
};

export type TemplateInstance = {
  __typename?: 'TemplateInstance';
  /** Moment when instance was created */
  createdAt: Scalars['Date']['output'];
  /** Values to overwrite in template for a specified format */
  formatValues: Maybe<Array<TemplateInstanceFormatValues>>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /**
   * Id of language the instance represents
   * @deprecated Please use higher level meta data to set what this instance is for
   */
  languageId: Maybe<Scalars['String']['output']>;
  /** Descriptive name */
  name: Maybe<Scalars['String']['output']>;
  /** Settings to use during rendering */
  renderSettings: Maybe<RenderSettings>;
  /** Id of template the instance belongs to */
  templateId: Scalars['ID']['output'];
  /** Url to thumbnail image for this instance */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** Moment when instance was updated */
  updatedAt: Maybe<Scalars['Date']['output']>;
  /** Values to overwrite in template */
  values: Maybe<Array<TemplateObjectChange>>;
  /**
   * Id of variant the instance represents
   * @deprecated Please use higher level meta data to set what this instance is for
   */
  variantId: Maybe<Scalars['String']['output']>;
};

export type TemplateInstanceCreate = {
  /** Values to overwrite in template for a specified format */
  formatValues?: InputMaybe<Array<TemplateInstanceFormatValuesInput>>;
  /** Id of language the instance represents */
  languageId?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Settings to use during rendering */
  renderSettings?: InputMaybe<RenderSettingsInput>;
  /** Id of template this instance uses */
  templateId: Scalars['ID']['input'];
  /** Initial values */
  values?: InputMaybe<Array<TemplateObjectChangeInput>>;
  /**
   * Id of variant the instance represents
   * @deprecated Please use higher level meta data to set what this instance is for
   */
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateInstanceFormatValues = {
  __typename?: 'TemplateInstanceFormatValues';
  /** Id of format to change values for */
  formatId: Scalars['String']['output'];
  /** Values to overwrite in template */
  values: Maybe<Array<TemplateObjectChange>>;
};

export type TemplateInstanceFormatValuesChangeInput = {
  /** Id of format to change values for */
  formatId: Scalars['String']['input'];
  /** Values to overwrite in template */
  values?: InputMaybe<Array<TemplateObjectChangeInput>>;
};

export type TemplateInstanceFormatValuesInput = {
  /** Id of format to change values for */
  formatId: Scalars['String']['input'];
  /** Values to overwrite in template */
  values?: InputMaybe<Array<TemplateObjectChangeInput>>;
};

export type TemplateInstanceUpdate = {
  /** Values to overwrite in template for a specified format */
  formatValues?: InputMaybe<Array<TemplateInstanceFormatValuesInput>>;
  /** Format values to add/change/delete */
  formatValuesChanges?: InputMaybe<Array<TemplateInstanceFormatValuesChangeInput>>;
  /** Id of language the instance represents */
  languageId?: InputMaybe<Scalars['String']['input']>;
  /** New name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Settings to use during rendering */
  renderSettings?: InputMaybe<RenderSettingsInput>;
  /** Values to add/change/delete */
  valueChanges?: InputMaybe<Array<TemplateObjectChangeInput>>;
  /**
   * Id of variant the instance represents
   * @deprecated Please use higher level meta data to set what this instance is for
   */
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateLayout = {
  __typename?: 'TemplateLayout';
  /** Ids of formats to use this layout for */
  formatIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Unique id */
  id: Scalars['ID']['output'];
  /** Descriptive name */
  name: Maybe<Scalars['String']['output']>;
  /** Layout objects */
  objects: Array<TemplateObject>;
};

export type TemplateLayoutInput = {
  /** Ids of formats to use this layout for */
  formatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Unique id */
  id: Scalars['ID']['input'];
  /** Descriptive name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Layout objects */
  objects: Array<Scalars['JSONObject']['input']>;
};

export type TemplateMask = TemplateObjectContent & {
  __typename?: 'TemplateMask';
  /**
   * Specific mask id.
   * If not set the id of the template object is used.
   */
  maskId: Maybe<Scalars['String']['output']>;
  /** Source to mask */
  src: Maybe<Scalars['String']['output']>;
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateMotion = {
  __typename?: 'TemplateMotion';
  /** Audio track to use for video */
  audio: Maybe<TemplateAudio>;
  /** Frames per second */
  fps: Scalars['Int']['output'];
  /** Length of template (in seconds) */
  length: Scalars['Float']['output'];
};

export type TemplateMotionInput = {
  /** Audio track to use for video */
  audio?: InputMaybe<TemplateAudioInput>;
  /** Frames per second */
  fps: Scalars['Int']['input'];
  /** Length of template (in seconds) */
  length: Scalars['Float']['input'];
};

export type TemplateObject = {
  __typename?: 'TemplateObject';
  /** Anchor inside object rect to place on position (in ratio) */
  anchor: Maybe<Vector2>;
  /** Animations */
  animations: Maybe<Array<TemplateObjectPropertyAnimation>>;
  /**
   * Fixed aspect ratio
   * If set will make sure that the aspect ratio is kept if the dimensions of the object are changed.
   * Ignored if both width and height are set.
   */
  aspectRatio: Maybe<Scalars['Float']['output']>;
  /**
   * Composite Operation
   * @link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   */
  compositeOperation: Maybe<Scalars['String']['output']>;
  /** Conditions */
  conditions: Maybe<Array<Condition>>;
  /** Content to render */
  content: Maybe<TemplateObjectContentTypes>;
  /** Indicates if the object is currently disabled */
  disabled: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if user can edit the object
   * @default false
   */
  editable: Maybe<Scalars['Boolean']['output']>;
  /**
   * Filter to use
   * @link https://developer.mozilla.org/en-US/docs/Web/CSS/filter
   */
  filter: Maybe<Scalars['String']['output']>;
  /** Filters to apply */
  filters: Maybe<TemplateObjectFilters>;
  /**
   * Axis-independent way of providing the default size of an item along the main axis
   * @default auto
   * @see https://yogalayout.com/docs/flex
   */
  flexBasis: Maybe<Length>;
  /**
   * How to distribute any space within a container among its children along the
   * main axis.
   * @default 0
   * @see https://yogalayout.com/docs/flex
   */
  flexGrow: Maybe<Scalars['Float']['output']>;
  /**
   * How to shrink children along the main axis of the container.
   * @default 0
   * @see https://yogalayout.com/docs/flex
   */
  flexShrink: Maybe<Scalars['Float']['output']>;
  /** Flips the object horizontally */
  flipX: Maybe<Scalars['Boolean']['output']>;
  /** Flips the object vertically */
  flipY: Maybe<Scalars['Boolean']['output']>;
  /** Height of template object */
  height: Maybe<Dimension>;
  /** Unique id */
  id: Maybe<Scalars['ID']['output']>;
  /** Margins around object */
  margin: Maybe<TemplateObjectMargin>;
  /** Id of mask to use */
  mask: Maybe<Scalars['String']['output']>;
  /** Name to describe object */
  name: Maybe<Scalars['String']['output']>;
  /** Absolute offset to position (in px) */
  offset: Maybe<Vector2>;
  /** Opacity */
  opacity: Maybe<Scalars['Float']['output']>;
  /**
   * Indicates if the object is optional
   * @default false
   */
  optional: Maybe<Scalars['Boolean']['output']>;
  /**
   * Order value to sort among sibling objects.
   * Determines render order.
   */
  order: Maybe<Scalars['Int']['output']>;
  /** Padding around content of object */
  padding: Maybe<TemplateObjectPadding>;
  /**
   * Id of parent container.
   * If set the object should be rendered inside `content.children` of a template container.
   */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Relative position of object (in ratio) */
  position: Maybe<Vector2>;
  /** Defines how it is positioned within its parent */
  positionType: Maybe<PositionType>;
  /** Rotation around pivot (in degree) */
  rotation: Maybe<Scalars['Float']['output']>;
  /** 3D Rotation around pivot (in degree) */
  rotation3d: Maybe<Vector3>;
  /** Scale */
  scale: Maybe<Scalars['Float']['output']>;
  /** Width of template object */
  width: Maybe<Dimension>;
  /** Z position */
  z: Maybe<Scalars['Int']['output']>;
};

export type TemplateObjectAddition = {
  /** Initial values for template object */
  initialValues?: InputMaybe<Array<TemplateObjectAdditionInitialValue>>;
  /** Name of template object to add */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateObjectAdditionInitialValue = {
  /** Path to property to initialize */
  path: Scalars['String']['input'];
  /** Value to set */
  value: Scalars['JSON']['input'];
};

export type TemplateObjectBackground = TemplateColor & {
  __typename?: 'TemplateObjectBackground';
  /**
   * Background color (hex code)
   * @default white
   */
  color: Maybe<Scalars['String']['output']>;
  /** Fixed options for color to choose from */
  colorOptions: Maybe<Array<TemplateColorOption>>;
  /**
   * Corner radius (in px)
   * @default 0
   */
  cornerRadius: Maybe<Scalars['Float']['output']>;
  /**
   * Padding (in px)
   * @default 0
   */
  padding: Maybe<Scalars['Float']['output']>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence over `color` property.
   */
  selectedColorOption: Maybe<Scalars['Int']['output']>;
};

export type TemplateObjectChange = {
  __typename?: 'TemplateObjectChange';
  /** Id of template object to change */
  id: Scalars['ID']['output'];
  /** Path to property to change */
  path: Scalars['String']['output'];
  /** Value to set. Leave empty to clear. */
  value: Maybe<Scalars['JSON']['output']>;
};

export type TemplateObjectChangeInput = {
  /** Id of template object to change */
  id: Scalars['ID']['input'];
  /** Path to property to change */
  path: Scalars['String']['input'];
  /** Value to set. Leave empty to clear. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type TemplateObjectContent = {
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateObjectContentTypes = TemplateContainer | TemplateEllipse | TemplateGradient | TemplateHolder | TemplateImage | TemplateImageSequence | TemplateMask | TemplateRectangle | TemplateText | TemplateVideo;

export type TemplateObjectDeletion = {
  /** Id of template object to delete */
  id: Scalars['ID']['input'];
};

export type TemplateObjectFilters = {
  __typename?: 'TemplateObjectFilters';
  /** Applies a Gaussian blur */
  blur: Maybe<BlurFilter>;
  /** Displacement filter */
  displacement: Maybe<DisplacementFilter>;
  /** Drop shadow */
  shadow: Maybe<ShadowFilter>;
};

export type TemplateObjectMargin = {
  __typename?: 'TemplateObjectMargin';
  bottom: Maybe<Length>;
  left: Maybe<Length>;
  right: Maybe<Length>;
  top: Maybe<Length>;
};

export type TemplateObjectPadding = {
  __typename?: 'TemplateObjectPadding';
  bottom: Maybe<Length>;
  left: Maybe<Length>;
  right: Maybe<Length>;
  top: Maybe<Length>;
};

export type TemplateObjectPropertyAnimation = {
  __typename?: 'TemplateObjectPropertyAnimation';
  /** Animation data */
  data: AnimationInterpolateData;
  /** Property to animate */
  property: Scalars['String']['output'];
};

export enum TemplateObjectType {
  Container = 'Container',
  Ellipse = 'Ellipse',
  Gradient = 'Gradient',
  Holder = 'Holder',
  Image = 'Image',
  ImageSequence = 'ImageSequence',
  Mask = 'Mask',
  Rectangle = 'Rectangle',
  Text = 'Text',
  Video = 'Video'
}

export type TemplateRectangle = TemplateColor & TemplateObjectContent & {
  __typename?: 'TemplateRectangle';
  /** Background behind content */
  background: Maybe<TemplateObjectBackground>;
  /** Color value (hex code) */
  color: Maybe<Scalars['String']['output']>;
  /**
   * Options for color to choose from.
   * If not set the user is free to choose any color.
   */
  colorOptions: Maybe<Array<TemplateColorOption>>;
  /**
   * Fixed height of rectangle (in px)
   * @deprecated Use `height` of TemplateObject
   * @deprecated Use `height` of TemplateObject
   */
  height: Maybe<Scalars['Float']['output']>;
  /**
   * Radius of edges (in px)
   * @default 0
   */
  radius: Maybe<Scalars['Float']['output']>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence over `color` property.
   */
  selectedColorOption: Maybe<Scalars['Int']['output']>;
  /** Type of content */
  type: TemplateObjectType;
  /**
   * Fixed width of rectangle (in px)
   * @deprecated Use `width` of TemplateObject
   * @deprecated Use `width` of TemplateObject
   */
  width: Maybe<Scalars['Float']['output']>;
};

/** Renders text content */
export type TemplateText = TemplateColor & TemplateObjectContent & {
  __typename?: 'TemplateText';
  /** Background behind content */
  background: Maybe<TemplateObjectBackground>;
  /** Blurring (in px) */
  blur: Maybe<Scalars['Int']['output']>;
  /** Clip text from start to the specified position (in ratio) */
  clip: Maybe<Scalars['Float']['output']>;
  /** Color value (hex code) */
  color: Maybe<Scalars['String']['output']>;
  /**
   * Options for color to choose from.
   * If not set the user is free to choose any color.
   */
  colorOptions: Maybe<Array<TemplateColorOption>>;
  /** Motion blur effect (in px/s) */
  motionBlur: Maybe<Scalars['Float']['output']>;
  /**
   * Option to use.
   * If set to an existent option it takes precedence over `color` property.
   */
  selectedColorOption: Maybe<Scalars['Int']['output']>;
  /**
   * Selected text option.
   * If set to an existent option it takes precedence before `text` property.
   */
  selectedTextOption: Maybe<SelectedTemplateTextOption>;
  /** Content of text object */
  text: Maybe<Scalars['String']['output']>;
  /** Fixed options to select from */
  textOptions: Maybe<Array<TemplateTextOption>>;
  /** Object renders text */
  textSettings: Maybe<TemplateTextSettings>;
  /** Type of content */
  type: TemplateObjectType;
};

export type TemplateTextOption = {
  __typename?: 'TemplateTextOption';
  /** Formatting text */
  formatText: Maybe<Scalars['String']['output']>;
  /** Variables to set in formatting text */
  variables: Maybe<Array<TemplateTextOptionVariable>>;
};

export type TemplateTextOptionVariable = {
  __typename?: 'TemplateTextOptionVariable';
  /** Key of variable */
  key: Maybe<Scalars['String']['output']>;
  /** Name of variable */
  name: Maybe<Scalars['String']['output']>;
};

export type TemplateTextOptionVariableMapping = {
  __typename?: 'TemplateTextOptionVariableMapping';
  /** Key of variable */
  key: Maybe<Scalars['String']['output']>;
  /** Value of variable */
  value: Maybe<Scalars['String']['output']>;
};

export type TemplateTextSettings = {
  __typename?: 'TemplateTextSettings';
  /** DO NOT USE. Only added to export FontWeightValue */
  _tmpFontWeight: Maybe<FontWeightValue>;
  /** Font to use */
  fontFamily: Maybe<Scalars['String']['output']>;
  /**
   * Font size to use (in px)
   * @default 16
   */
  fontSize: Maybe<Scalars['Int']['output']>;
  /**
   * Factor to multiply font size with (as ratio)
   * @default 1.0
   */
  fontSizeFactor: Maybe<Scalars['Float']['output']>;
  /**
   * Style of font (e.g. italic)
   * @default normal
   */
  fontStyle: Maybe<FontStyle>;
  /** Weight of font (e.g. bold) */
  fontWeight: Maybe<FontWeight>;
  /** Additional horizontal spacing between characters (in px) */
  letterSpacing: Maybe<Scalars['Int']['output']>;
  /** Maximum font size to use (in px) */
  maxFontSize: Maybe<Scalars['Int']['output']>;
  /** Minimum font size to use (in px) */
  minFontSize: Maybe<Scalars['Int']['output']>;
  /** Indicates and sets up shadow to use */
  shadow: Maybe<TextShadow>;
  /** Horizontal text alignment */
  textAlign: Maybe<TextAlign>;
  /** Vertical text align */
  textBaseline: Maybe<TextBaseline>;
  /**
   * Indicates if the text is allowed to wrap
   * @default false
   */
  wordWrap: Maybe<Scalars['Boolean']['output']>;
};

export type TemplateUpdate = {
  /** Ids of clients the template belongs to */
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** New condition sets */
  conditionSets?: InputMaybe<Array<ConditionSetInput>>;
  /** Export targets that are disabled for this template */
  disabledRenderingExportTargets?: InputMaybe<Array<RenderingExportTarget>>;
  /** New fonts */
  fonts?: InputMaybe<Array<FontInput>>;
  /** Ids of new formats */
  formatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** New layouts */
  layouts?: InputMaybe<Array<TemplateLayoutInput>>;
  /**
   * New motion
   * Send null to clear it
   */
  motion?: InputMaybe<TemplateMotionInput>;
  /** New name */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * New template objects
   * If set, this will completely overwrite the template objects
   */
  objects?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  /** Template objects to add */
  templateObjectAdditions?: InputMaybe<Array<TemplateObjectAddition>>;
  /** Values to add/change/delete */
  templateObjectChanges?: InputMaybe<Array<TemplateObjectChangeInput>>;
  /** Template objects to delete */
  templateObjectDeletions?: InputMaybe<Array<TemplateObjectDeletion>>;
  /** Variable mappings of the template */
  variableMappings?: InputMaybe<Array<TemplateVariableMappingInput>>;
};

export type TemplateVariableMapping = {
  __typename?: 'TemplateVariableMapping';
  /** Id of template object to change */
  id: Scalars['ID']['output'];
  /** Path to property of template object to change */
  path: Scalars['String']['output'];
  /** Key of variable to get value for */
  variableKey: Scalars['String']['output'];
};

export type TemplateVariableMappingInput = {
  /** Id of template object to change */
  id: Scalars['ID']['input'];
  /** Path to property of template object to change */
  path: Scalars['String']['input'];
  /** Key of variable to get value for */
  variableKey: Scalars['String']['input'];
};

export type TemplateVideo = TemplateObjectContent & {
  __typename?: 'TemplateVideo';
  /** Fixed height to use (in px) */
  height: Maybe<Scalars['Float']['output']>;
  /**
   * Speed factor to play video with
   * Can be negative to play the video in reverse
   * @default 1
   */
  speed: Maybe<Scalars['Float']['output']>;
  /** Url to source */
  src: Maybe<Scalars['String']['output']>;
  /**
   * Time offset if the video should not start immediately (in s)
   * @default 0
   */
  timeOffset: Maybe<Scalars['Float']['output']>;
  /** Type of content */
  type: TemplateObjectType;
  /** Fixed width to use (in px) */
  width: Maybe<Scalars['Float']['output']>;
};

export enum TextAlign {
  Center = 'center',
  End = 'end',
  Left = 'left',
  Right = 'right',
  Start = 'start'
}

export enum TextBaseline {
  Alphabetic = 'alphabetic',
  Bottom = 'bottom',
  Hanging = 'hanging',
  Ideographic = 'ideographic',
  Middle = 'middle',
  Top = 'top'
}

export type TextShadow = {
  __typename?: 'TextShadow';
  /**
   * Transparency (in ratio, 0 to 1)
   * @default 1
   */
  alpha: Maybe<Scalars['Float']['output']>;
  /**
   * Angle (in degree)
   * @default 60
   */
  angle: Maybe<Scalars['Float']['output']>;
  /**
   * Blur radius (in px)
   * @default 0
   */
  blur: Maybe<Scalars['Float']['output']>;
  /**
   * Color (hex code)
   * @default black
   */
  color: Maybe<Scalars['String']['output']>;
  /**
   * Distance to text (in px)
   * @default 5
   */
  distance: Maybe<Scalars['Float']['output']>;
};

export type TranslationRequest = {
  /** Target language */
  targetLanguageCode: Scalars['String']['input'];
  /** Text to translate */
  text: Scalars['String']['input'];
};

export type TranslationResponse = {
  __typename?: 'TranslationResponse';
  /** Translated text */
  translation: Scalars['String']['output'];
};

export type UpdateCampaignInput = {
  /** Id of client the campaign belongs to */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Items that belong to this campaign
   * Send an empty list to clear
   */
  items?: InputMaybe<Array<CampaignItemInput>>;
  /** Ids of languages that this campaign supports */
  languageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Descriptive name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New settings */
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateClientTemplateFormatInput = {
  /** Changes to do to format */
  format: UpdateTemplateFormatInput;
};

export type UpdateTemplateFormatInput = {
  /** Id of group the format belongs to */
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Height (in px) */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the format exports to a print asset */
  isPrint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of layout the format uses */
  layoutId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of format */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Scale factor to use on export */
  scale?: InputMaybe<Scalars['Float']['input']>;
  /** Width (in px) */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Active client */
  client: Maybe<Client>;
  /** Mail address of user */
  email: Maybe<Scalars['String']['output']>;
  /** Name of user */
  name: Maybe<Scalars['String']['output']>;
};

export type Vector2 = {
  __typename?: 'Vector2';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type Vector3 = {
  __typename?: 'Vector3';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type DeleteAssetMutationVariables = Exact<{
  deleteAssetId: Scalars['ID']['input'];
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: { __typename?: 'Asset', id: string } };

export type UploadAssetMutationVariables = Exact<{
  file: Scalars['FileUpload']['input'];
  input: AssetInput;
}>;


export type UploadAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'Asset', id: string, name: string, url: string } };

export type CreateCampaignMutationVariables = Exact<{
  input: CampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'Campaign', id: string, name: string } };

export type DeleteCampaignMutationVariables = Exact<{
  deleteCampaignId: Scalars['ID']['input'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign: { __typename?: 'Campaign', id: string } };

export type DuplicateCampaignItemMutationVariables = Exact<{
  input: DuplicateCampaignItemInput;
}>;


export type DuplicateCampaignItemMutation = { __typename?: 'Mutation', duplicateCampaignItem: { __typename?: 'CampaignItem', id: string, name: string | null } };

export type DuplicateCampaignMutationVariables = Exact<{
  input: DuplicateCampaignInput;
}>;


export type DuplicateCampaignMutation = { __typename?: 'Mutation', duplicateCampaign: { __typename?: 'Campaign', id: string, name: string } };

export type UpdateCampaignItemsMutationVariables = Exact<{
  updateCampaignId: Scalars['ID']['input'];
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignItemsMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'Campaign', id: string } };

export type UpdateCampaignMutationVariables = Exact<{
  updateCampaignId: Scalars['ID']['input'];
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename?: 'Campaign', id: string } };

export type CreateClientFormatMutationVariables = Exact<{
  input: CreateClientTemplateFormatInput;
}>;


export type CreateClientFormatMutation = { __typename?: 'Mutation', createClientFormat: { __typename?: 'ClientTemplateFormat', id: string, templateId: string, formatId: string } };

export type RenderTemplateInstanceMutationVariables = Exact<{
  templateInstanceId: Scalars['ID']['input'];
  input: RenderingInput;
}>;


export type RenderTemplateInstanceMutation = { __typename?: 'Mutation', renderTemplateInstance: { __typename?: 'Rendering', id: string, status: RenderingStatus, end: any | null, finishedNotificationMailAddress: string | null, result: { __typename?: 'RenderingError', message: string } | { __typename?: 'RenderingResult', url: string } | null } };

export type UpdateBannerSettingsMutationVariables = Exact<{
  updateTemplateInstanceId: Scalars['ID']['input'];
  data: TemplateInstanceUpdate;
}>;


export type UpdateBannerSettingsMutation = { __typename?: 'Mutation', updateTemplateInstance: { __typename?: 'TemplateInstance', renderSettings: { __typename?: 'RenderSettings', bannerSettings: { __typename?: 'BannerSettings', loop: boolean | null, targetUrl: string | null } | null } | null } };

export type UpdateInstanceChangeObjectMutationVariables = Exact<{
  updateTemplateInstanceId: Scalars['ID']['input'];
  data: TemplateInstanceUpdate;
}>;


export type UpdateInstanceChangeObjectMutation = { __typename?: 'Mutation', updateTemplateInstance: { __typename?: 'TemplateInstance', name: string | null, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null, formatValues: Array<{ __typename?: 'TemplateInstanceFormatValues', formatId: string, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null }> | null } };

export type UpdateTemplateInstanceMutationVariables = Exact<{
  updateTemplateInstanceId: Scalars['ID']['input'];
  data: TemplateInstanceUpdate;
}>;


export type UpdateTemplateInstanceMutation = { __typename?: 'Mutation', updateTemplateInstance: { __typename?: 'TemplateInstance', id: string } };

export type CreateRenderingJobMutationVariables = Exact<{
  input: RenderingJobInput;
}>;


export type CreateRenderingJobMutation = { __typename?: 'Mutation', createRenderingJob: { __typename?: 'RenderingJob', id: string } };

export type CampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, createdAt: any, items: Array<{ __typename?: 'CampaignItem', id: string, name: string | null, instances: Array<{ __typename?: 'CampaignItemInstance', templateInstance: { __typename?: 'TemplateInstance', formatValues: Array<{ __typename?: 'TemplateInstanceFormatValues', formatId: string }> | null } | null }> | null }> | null, languages: Array<{ __typename?: 'Language', id: string, name: string }> | null }> };

export type GetCampaignByIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetCampaignByIdQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, createdAt: any, updatedAt: any | null, name: string, clientId: string | null, languageIds: Array<string> | null, settings: any | null, items: Array<{ __typename?: 'CampaignItem', id: string, name: string | null, settings: any | null, templateId: string, instances: Array<{ __typename?: 'CampaignItemInstance', templateInstance: { __typename?: 'TemplateInstance', formatValues: Array<{ __typename?: 'TemplateInstanceFormatValues', formatId: string }> | null } | null }> | null }> | null } };

export type GetCampaignDetailsByIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetCampaignDetailsByIdQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, name: string, items: Array<{ __typename?: 'CampaignItem', id: string, name: string | null, templateId: string, template: { __typename?: 'Template', id: string, name: string, formatIds: Array<string> | null, clientId: string | null, outputChannels: Array<OutputChannel> | null, formats: Array<{ __typename?: 'TemplateFormat', id: string, groupId: string | null, name: string, width: number, height: number, scale: number | null }> | null, formatGroups: Array<{ __typename?: 'TemplateFormatGroup', id: string, name: string, formats: Array<{ __typename?: 'TemplateFormat', id: string, groupId: string | null, name: string, width: number, height: number }> | null }> | null, instances: Array<{ __typename?: 'TemplateInstance', id: string, languageId: string | null, name: string | null, templateId: string }> | null, clientFormats: Array<{ __typename?: 'ClientTemplateFormat', formatId: string, format: { __typename?: 'TemplateFormat', id: string, name: string, width: number, height: number } | null }> | null } | null, instances: Array<{ __typename?: 'CampaignItemInstance', id: string, templateInstanceId: string, languageId: string, templateInstance: { __typename?: 'TemplateInstance', id: string, createdAt: any, updatedAt: any | null, templateId: string, name: string | null, languageId: string | null } | null, language: { __typename?: 'Language', id: string, name: string } | null }> | null }> | null } };

export type GetCampaignItemInstancesByIdQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type GetCampaignItemInstancesByIdQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', id: string, name: string, items: Array<{ __typename?: 'CampaignItem', id: string, instances: Array<{ __typename?: 'CampaignItemInstance', id: string, templateInstanceId: string, languageId: string, templateInstance: { __typename?: 'TemplateInstance', id: string, createdAt: any, updatedAt: any | null, templateId: string, name: string | null, languageId: string | null, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null } | null, language: { __typename?: 'Language', id: string, name: string } | null }> | null }> | null } };

export type CampaignItemsQueryVariables = Exact<{
  query: CampaignItemQuery;
}>;


export type CampaignItemsQuery = { __typename?: 'Query', campaignItems: Array<{ __typename?: 'CampaignItem', id: string, name: string | null, createdAt: any, updatedAt: any | null, templateId: string, instances: Array<{ __typename?: 'CampaignItemInstance', languageId: string, templateInstanceId: string, thumbnailUrl: string | null, language: { __typename?: 'Language', id: string, name: string } | null, templateInstance: { __typename?: 'TemplateInstance', formatValues: Array<{ __typename?: 'TemplateInstanceFormatValues', formatId: string }> | null } | null }> | null, template: { __typename?: 'Template', id: string, name: string, outputChannels: Array<OutputChannel> | null, motion: { __typename?: 'TemplateMotion', fps: number, length: number } | null, formats: Array<{ __typename?: 'TemplateFormat', groupId: string | null, name: string, width: number, height: number }> | null, instances: Array<{ __typename?: 'TemplateInstance', id: string, name: string | null, languageId: string | null, templateId: string }> | null } | null }> };

export type TemplateInstanceQueryVariables = Exact<{
  templateInstanceId: Scalars['ID']['input'];
}>;


export type TemplateInstanceQuery = { __typename?: 'Query', templateInstance: { __typename?: 'TemplateInstance', name: string | null, id: string, templateId: string, languageId: string | null, variantId: string | null, formatValues: Array<{ __typename?: 'TemplateInstanceFormatValues', formatId: string, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null }> | null, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null, renderSettings: { __typename?: 'RenderSettings', bannerSettings: { __typename?: 'BannerSettings', targetUrl: string | null, loop: boolean | null } | null } | null } };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, name: string }> };

export type GetClientLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientLogoQuery = { __typename?: 'Query', me: { __typename?: 'User', client: { __typename?: 'Client', logoUrl: string | null } | null } | null };

export type GetClientNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientNameQuery = { __typename?: 'Query', me: { __typename?: 'User', client: { __typename?: 'Client', name: string | null } | null } | null };

export type GetAllTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, name: string }> };

export type GetTemplateByIdQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GetTemplateByIdQuery = { __typename?: 'Query', template: { __typename?: 'Template', id: string, name: string, playerTemplate: any | null, renderingExportTargets: Array<RenderingExportTarget> | null, formats: Array<{ __typename?: 'TemplateFormat', id: string, groupId: string | null, name: string, width: number, height: number }> | null, instances: Array<{ __typename?: 'TemplateInstance', id: string, templateId: string, name: string | null, languageId: string | null, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null, renderSettings: { __typename?: 'RenderSettings', bannerSettings: { __typename?: 'BannerSettings', targetUrl: string | null, loop: boolean | null } | null } | null }> | null, clientFormats: Array<{ __typename?: 'ClientTemplateFormat', format: { __typename?: 'TemplateFormat', id: string, groupId: string | null, name: string, width: number, height: number, layoutId: string | null } | null }> | null } };

export type GetTemplateFormatsQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GetTemplateFormatsQuery = { __typename?: 'Query', template: { __typename?: 'Template', formats: Array<{ __typename?: 'TemplateFormat', name: string, width: number, height: number }> | null } };

export type GetTemplateInstancesQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GetTemplateInstancesQuery = { __typename?: 'Query', template: { __typename?: 'Template', instances: Array<{ __typename?: 'TemplateInstance', id: string, templateId: string, languageId: string | null, name: string | null, values: Array<{ __typename?: 'TemplateObjectChange', id: string, path: string, value: any | null }> | null }> | null } };

export type GetTemplateMotionLengthQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GetTemplateMotionLengthQuery = { __typename?: 'Query', template: { __typename?: 'Template', motion: { __typename?: 'TemplateMotion', length: number } | null } };

export type RenderingStatusChangedSubscriptionVariables = Exact<{
  renderingStatusChangedId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RenderingStatusChangedSubscription = { __typename?: 'Subscription', renderingStatusChanged: { __typename?: 'Rendering', id: string, status: RenderingStatus, result: { __typename?: 'RenderingError', message: string } | { __typename?: 'RenderingResult', downloadUrl: string } | null } };

export type SubscriptionSubscriptionVariables = Exact<{
  renderingJobStatusChangedId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SubscriptionSubscription = { __typename?: 'Subscription', renderingJobStatusChanged: { __typename?: 'RenderingJob', id: string, status: RenderingJobStatus, result: { __typename?: 'RenderingJobError', message: string } | { __typename?: 'RenderingJobSuccess', url: string } | null } };

export type AssetsQueryVariables = Exact<{
  assetQuery: AssetQuery;
}>;


export type AssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetQueryResult', limit: number | null, offset: number | null, page: number | null, totalCount: number, items: Array<{ __typename?: 'Asset', id: string, name: string, groups: Array<AssetGroup> | null, url: string, thumbnailUrl: string, bright: boolean | null, deletable: boolean | null }> | null } };


export const DeleteAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAssetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAssetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAssetMutation, DeleteAssetMutationVariables>;
export const UploadAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUpload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UploadAssetMutation, UploadAssetMutationVariables>;
export const CreateCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const DeleteCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteCampaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteCampaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const DuplicateCampaignItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"duplicateCampaignItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateCampaignItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateCampaignItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DuplicateCampaignItemMutation, DuplicateCampaignItemMutationVariables>;
export const DuplicateCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"duplicateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DuplicateCampaignMutation, DuplicateCampaignMutationVariables>;
export const UpdateCampaignItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCampaignItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCampaignItemsMutation, UpdateCampaignItemsMutationVariables>;
export const UpdateCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const CreateClientFormatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateClientFormat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateClientTemplateFormatInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClientFormat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"formatId"}}]}}]}}]} as unknown as DocumentNode<CreateClientFormatMutation, CreateClientFormatMutationVariables>;
export const RenderTemplateInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenderTemplateInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderTemplateInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateInstanceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateInstanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"finishedNotificationMailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RenderTemplateInstanceMutation, RenderTemplateInstanceMutationVariables>;
export const UpdateBannerSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBannerSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateInstanceUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemplateInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bannerSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loop"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBannerSettingsMutation, UpdateBannerSettingsMutationVariables>;
export const UpdateInstanceChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateInstanceChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateInstanceUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemplateInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formatValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInstanceChangeObjectMutation, UpdateInstanceChangeObjectMutationVariables>;
export const UpdateTemplateInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTemplateInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateInstanceUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTemplateInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTemplateInstanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTemplateInstanceMutation, UpdateTemplateInstanceMutationVariables>;
export const CreateRenderingJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRenderingJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingJobInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRenderingJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRenderingJobMutation, CreateRenderingJobMutationVariables>;
export const CampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CampaignsQuery, CampaignsQueryVariables>;
export const GetCampaignByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCampaignById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"languageIds"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>;
export const GetCampaignDetailsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCampaignDetailsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"scale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formatIds"}},{"kind":"Field","name":{"kind":"Name","value":"formatGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"outputChannels"}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientFormats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}},{"kind":"Field","name":{"kind":"Name","value":"format"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstanceId"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignDetailsByIdQuery, GetCampaignDetailsByIdQueryVariables>;
export const GetCampaignItemInstancesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignItemInstancesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstanceId"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignItemInstancesByIdQuery, GetCampaignItemInstancesByIdQueryVariables>;
export const CampaignItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignItemQuery"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstanceId"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"motion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fps"}},{"kind":"Field","name":{"kind":"Name","value":"length"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputChannels"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignItemsQuery, CampaignItemsQueryVariables>;
export const TemplateInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateInstanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateInstance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateInstanceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatId"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"renderSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bannerSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"loop"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TemplateInstanceQuery, TemplateInstanceQueryVariables>;
export const GetLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetClientLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetClientLogoQuery, GetClientLogoQueryVariables>;
export const GetClientNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetClientNameQuery, GetClientNameQueryVariables>;
export const GetAllTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllTemplatesQuery, GetAllTemplatesQueryVariables>;
export const GetTemplateByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTemplateById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"renderSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bannerSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"loop"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playerTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"renderingExportTargets"}},{"kind":"Field","name":{"kind":"Name","value":"clientFormats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"layoutId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateByIdQuery, GetTemplateByIdQueryVariables>;
export const GetTemplateFormatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTemplateFormats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateFormatsQuery, GetTemplateFormatsQueryVariables>;
export const GetTemplateInstancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTemplateInstances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"languageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateInstancesQuery, GetTemplateInstancesQueryVariables>;
export const GetTemplateMotionLengthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTemplateMotionLength"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"motion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"length"}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateMotionLengthQuery, GetTemplateMotionLengthQueryVariables>;
export const RenderingStatusChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"RenderingStatusChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"renderingStatusChangedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingStatusChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"renderingStatusChangedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RenderingStatusChangedSubscription, RenderingStatusChangedSubscriptionVariables>;
export const SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Subscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"renderingJobStatusChangedId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renderingJobStatusChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"renderingJobStatusChangedId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingJobSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RenderingJobError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionSubscription, SubscriptionSubscriptionVariables>;
export const AssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetQuery"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bright"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AssetsQuery, AssetsQueryVariables>;